// extracted by mini-css-extract-plugin
export default {"cardOverlayStack":"CardOverlayPage_cardOverlayStack__6tg4Y"};